import { type Category, type Product } from '@prisma/client'
import { StarRating } from './star-rating'

interface Props {
	product: Pick<Product, 'name' | 'year'> & { category: Pick<Category, 'name'> }
	averageRating: number
	reviewsCount: number
	reviewsWithContentCount: number
	className?: string
}

export const ProductTitle = ({
	product,
	averageRating,
	reviewsCount,
	reviewsWithContentCount,
	className,
}: Props) => {
	return (
		<div className={`flex flex-col gap-2 ${className}`}>
			<div>
				<h6 className="text-h6 leading-7 max-sm:text-xl">{product.name}</h6>
				<p className="text-muted-foreground">
					{product.category.name} {product.category.name && product.year && '•'}{' '}
					{product.year}
				</p>
			</div>
			<div className="flex gap-2 text-lg text-secondary-600">
				<span className="font-bold max-sm:text-base">
					{averageRating.toFixed(2)}
				</span>
				<StarRating
					rating={averageRating}
					clickable={false}
					filledColor="text-color-600"
					className="max-sm:text-base"
				/>
				<p className="max-sm:text-base">
					{reviewsCount} ratings • {reviewsWithContentCount} reviews
				</p>
			</div>
		</div>
	)
}
